import React, { useEffect, useState } from 'react'
import './momentum-removal.styles.scss';
import coin from '@/assets/icons/coin.png';
import gem from '@/assets/icons/xp.png';
import ItemSelector from '../blocks/item-selector.component';
import ToggleInput from '@/components/SHARED/toggle-input/toggle-input.component';
import { useGameTerms } from '@/utils/gameTerms';

const MomentumRemoval = ({ formData, saveData, gameElements, gameData, gameStats }) => {

  const [removableItems, setRemovableItems] = useState([]);
  const terms = useGameTerms();

  useEffect(() => {
    if (!gameElements) return;
    setRemovableItems(
      Object.values(gameElements).filter(e =>
        e.type === 'item' &&
        e.status === 'active' &&
        (e.opt_itemType === 'inventory' || e.opt_itemType === 'collectible')
      )
    );
  }, [gameElements]);

  return (
    <div className='momentum-removal g-list-item form-section'>
      <h3>What to Remove</h3>
      <hr />
      <div className='toggle-with-text'>
        <ToggleInput
          contentKey="opt_removeTransfer"
          checked={formData.opt_removeTransfer}
          saveData={saveData} />
        <div className='toggle-text'>
          <div><b>Transfer Items or {terms.currency.plural} to Another Player?</b></div>
          <div className='meta'>By selecting this option, the player who receives the Momentum Card will have the option
            to transfer the removed items or {terms.currency.pluralLower} to another player instead of having them taken away. If this option is not selected,
            the items or {terms.currency.pluralLower} will simply be removed from the player's account.
          </div>
        </div>
      </div>
      <hr />
      <p>Choose what will be taken from a player when they receive this Momentum Card. Leave any of these blank to skip that removal.</p>
      {
        (gameData && gameData.access.includes('points')) &&
        <div>
          <h3>XP</h3>
          <div className='field small'>
            <label className='meta'>How much XP should be removed?</label>
            <div className='input-with-icon'>
              <img src={gem} alt='XP' />
              <input
                type='number'
                className='short-input'
                placeholder='Amount to Remove'
                min={0}
                value={formData.opt_removeXp ?? ''}
                onChange={(e) => saveData('opt_removeXp', Number(e.target.value))}
              />
            </div>
          </div>
          <div className='g-space-1'></div>
        </div>
      }
      {
        (gameData && gameData.access.includes('currency')) &&
        <div>
          <h3>{terms.currency.plural}</h3>
          <div className='field small'>
            <label className='meta'>How many {terms.currency.pluralLower} should be removed?</label>
            <div className='input-with-icon'>
              <img src={coin} alt='currency' />
              <input
                type='number'
                className='short-input'
                placeholder='Amount to Remove'
                min={0}
                value={formData.opt_removeCurrency ?? ''}
                onChange={(e) => saveData('opt_removeCurrency', Number(e.target.value))}
              />
            </div>
          </div>
          <div className='g-space-1'></div>
        </div>
      }
      {
        (gameData && gameData.access.includes('items') && removableItems.length > 0) &&
        <div>
          <h3>Items</h3>
          <p className='meta'>
            Select inventory items or collectibles to remove. For collectibles, only those not part of a completed collection set will be removed.
          </p>
          <ItemSelector
            type='distribute'
            formData={formData}
            saveData={saveData}
            gameElements={removableItems}
            gameStats={gameStats}
            gameData={gameData}
            headText={null}
            inst={null}
            saveKey='opt_removeItems'
          />
          <div className='g-space-1'></div>
        </div>
      }
    </div>
  )
}

export default MomentumRemoval
